import type { EndTurnCommand, EndTurnFrame } from './end-turn.js';
import { ftClockColsFromArr, ftClockCalendarFromArr, ftCampaignTimeAddSeconds } from '../../shared/campaign-clock.js';

type Row = Record<string, unknown>;
type ClockWrites = Partial<Record<`campaign_time_${'year' | 'month' | 'day' | 'hour' | 'minute' | 'second'}`, number>>;
export type TurnCommitFrame = EndTurnFrame & { campaign_clock?: ClockWrites };
export type TurnCommitCommand = EndTurnCommand & { campaign_clock: ClockWrites; campaign_clock_before: ClockWrites; frame: TurnCommitFrame };
const units = ['year', 'month', 'day', 'hour', 'minute', 'second'] as const;

/** Project the resolver's decided duration onto the held checkpoint. Keep its running-since
 * anchor: advancing the checkpoint advances a running clock without folding elapsed time twice. */
export function turnCommitFrame(command: EndTurnCommand, campaign: Row): TurnCommitCommand {
  const before: ClockWrites = {}, after: ClockWrites = {};
  const calendar = ftClockCalendarFromArr(campaign);
  if (command.frame.clock_seconds && calendar.months.length) {
    const cols = ftClockColsFromArr(campaign);
    const next = ftCampaignTimeAddSeconds(cols, calendar, command.frame.clock_seconds);
    for (const unit of units) { before[`campaign_time_${unit}`] = cols[unit]; after[`campaign_time_${unit}`] = next[unit]; }
  }
  return { ...command, campaign_clock: after, campaign_clock_before: before,
    frame: Object.keys(after).length ? { ...command.frame, campaign_clock: after } : command.frame };
}

/** Absolute checkpoint patch, idempotent for a repeated saved frame. */
export function applyTurnCommitClock(campaign: Row, frame: TurnCommitFrame): boolean {
  if (!frame.campaign_clock) return false;
  const bucket = (campaign.campaigns ??= {}) as Row;
  for (const unit of units) {
    const column = `campaign_time_${unit}` as const;
    if (column in frame.campaign_clock) bucket[column] = frame.campaign_clock[column];
  }
  return true;
}
